module.exports = __webpack_public_path__ + "static/mamadeira-ab22cbf8157bd1d98882ed92a1e35732.png";